import {LinearGradient} from 'expo-linear-gradient';
import React from 'react';



// <Gradient
//           colors={['#265CFF', '#7592EA']}
//           locations={[0.017, 0.65]}
//           end={{x: 0.1, y: 0.4}}
//           style={{height: 60}}>
//           <View>
//             <Text>1</Text>
//             <Text>1</Text>
//             <Text>1</Text>
//           </View>
//         </Gradient>

const Gradient = ({colors, locations, start, end, children, style}) => {
  return (
    <LinearGradient
      colors={colors || ['#ffffff']}
      locations={locations}
      end={end || {x: 1, y: -1}}
      style={style}
      start={start}>
      {children}
    </LinearGradient>
  );
};

export default Gradient;
